export const popover = {
  colorScheme: {
    light: {
      color: '{neutral.900}',
      root: {},
      background: '{surface.100}',
      borderColor: '{surface.600}',
      disabled: {
        background: '#efefef',
        color: '#dadada',
        borderColor: '#eaeaea',
        opacity: '0.8',
        label: 'red',
      },
    },
    dark: {
      background: '#333643',
      color: 'white',
      borderColor: '#5B5F69',
      placeholderColor: '#aeaeae',
      root: {
        focusBorderColor: 'var(--p-primary-color)',
        hoverBorderColor: 'var(--p-primary-color)',
      },
      disabled: {
        background: '#393d49ff',
        color: '#5B5F69',
        borderColor: '#5B5F69',
        opacity: '0.8',
      },
    },
  },
};
